import React from 'react';
import './Modal.css';

// Modal genérico para feedback positivo de ações (salvar, excluir, adicionar)
const ModalSuccess = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card blue-theme">
        <button className="btn-close-modal" onClick={onClose}>&times;</button>
        <p className="modal-message">{message}</p>
      </div>
    </div>
  );
};

export default ModalSuccess;